import {
	OverlaTopCommandName,
	OverlayBtn,
	OverlayContain,
	OverlayTop,
	OverlayTopCommandType,
	OverlayTopPriceContain,
	OverlayTopTitle,
	OverlayWrapper,
	OverlayInput,
	OverlayInputContain,
	OverlayInputLabel,
	OverlayInputContainer,
	CoolDownCommandContainer,
	ImgFreezitem,
	OverlayImageContainer,
	OverlayImgPreviewbtn,
	OverlayVideoWrapper,
} from './Overlay.styles';
import Images from 'src/App/Images';
import { useEffect, useState } from 'react';
import { GlobalColors } from 'src/App/Styles/Globals';
import { useAppSelector } from 'src/App/redux/hooks';
import { RootState } from 'src/App/redux/store';
import { RenderBitsIcon } from '../ImagesRender/RenderBitsIcon';
import { toast } from 'react-toastify';
import { hfxGetUrl } from 'src/App/Helpers/hfxGetUrl';

export function OverlayHfx({ close, triggerCommand, command, showImage = false }) {
	const hasSharedIdentity = useAppSelector((state: RootState) => process.env.REACT_APP_BYPASS_AUTH ?? state.app.hasSharedIdentity);
	const currentCooldowns = useAppSelector((state: RootState) => state.app.currentCooldowns);
	const [processing, setProcessing] = useState(false);
	const [hfxVideo] = useState(hfxGetUrl(command, false));
	const [preview] = useState(hfxGetUrl(command, true));
	const [error, setError] = useState('');
	const [prompt, setPrompt] = useState('');
	const [focused, setFocused] = useState(false);
	const [videoPreviewModalOpen, setVideoPreviewModalOpen] = useState(false);
	const [cooldown, setCooldown] = useState<string | null>(null);
	const [cooldownSecondsLeft, setCooldownSecondsLeft] = useState<number>(0);

	useEffect(() => {
		let timerId;
		if (currentCooldowns['channel'] || currentCooldowns[command.name]) {
			timerId = setInterval(() => {
				setCooldownSecondsLeft(cooldownSecondsLeft - 1);
			}, 1000);
		}

		return () => clearInterval(timerId);
	});

	useEffect(() => {
		if (currentCooldowns['channel'] || currentCooldowns[command.name]) {
			setCooldown(((currentCooldowns['channel'] || currentCooldowns[command.name]) / 1000).toFixed(1));
			setCooldownSecondsLeft(Math.round((currentCooldowns['channel'] || currentCooldowns[command.name]) / 1000));
		} else {
			setCooldown(null);
			setCooldownSecondsLeft(0);
		}
	}, [currentCooldowns['channel'], currentCooldowns[command.name]]);

	async function handleTrigger() {
		if (!processing && (!command.prompt || prompt)) {
			setProcessing(true);
			try {
				let finalPrompt = prompt;
				if (finalPrompt) {
					finalPrompt = finalPrompt.substring(0, 500);
				}
				await triggerCommand({ ...command, prompt: finalPrompt });
				setProcessing(false);
				close();
				toast.success('Success');
			} catch (err: any) {
				console.error('err: ', err);
				close();
				toast.error(err);
				setError(err);
				setProcessing(false);
			}
		}
	}

	function popupGrant() {
		const twitch = globalThis.Twitch ? globalThis.Twitch.ext : null; // If the extension is running on twitch or dev rig, set the shorthand here. otherwise, set to null.
		twitch.actions.requestIdShare();
	}

	function togglePreviewModal() {
		setVideoPreviewModalOpen(!videoPreviewModalOpen);
	}

	return (
		<OverlayContain>
			{videoPreviewModalOpen ? (
				<OverlayTop>
					<OverlayVideoWrapper>
						<OverlayTopTitle>
							<Images.Close onClick={togglePreviewModal} />
						</OverlayTopTitle>
						<video src={hfxVideo} autoPlay controls />
					</OverlayVideoWrapper>
				</OverlayTop>
			) : (
				<OverlayWrapper>
					<OverlayTop>
						<OverlayTopTitle>
							<Images.Close onClick={close} />
						</OverlayTopTitle>
						<OverlaTopCommandName>
							<h1>{command.label}</h1>
						</OverlaTopCommandName>
						{showImage && (
							<OverlayImageContainer>
								<OverlayImgPreviewbtn onClick={togglePreviewModal} style={{ zIndex: 10 }}>
									<Images.Play /> Preview
								</OverlayImgPreviewbtn>
								<img loading="lazy" src={preview} alt={command.hfx} />
							</OverlayImageContainer>
						)}
						<OverlayTopCommandType>{command.description}</OverlayTopCommandType>

						{command.prompt && !cooldown && (
							<OverlayInputContain>
								<OverlayInputLabel>Enter Prompt</OverlayInputLabel>
								<OverlayInputContainer
									style={{
										border: `1px solid ${focused ? GlobalColors.pinkSamen : '#878787'}`,
									}}
								>
									<OverlayInput
										maxLength={500}
										onFocus={() => {
											setFocused(true);
										}}
										onBlur={() => {
											setFocused(false);
										}}
										placeholder="Prompt is required"
										onChange={(e) => setPrompt(e.target.value)}
									/>
								</OverlayInputContainer>
							</OverlayInputContain>
						)}

						<OverlayTopPriceContain>
							{command.bits > 0 ? (
								<>
									{command.bits} Bits
									<RenderBitsIcon bits={command.bits} />
								</>
							) : (
								<>Free</>
							)}
						</OverlayTopPriceContain>
					</OverlayTop>
					{cooldown ? (
						<CoolDownCommandContainer>
							<span>Currently in a cooldown for {cooldownSecondsLeft} seconds</span>
							<ImgFreezitem />
						</CoolDownCommandContainer>
					) : (
						<OverlayBtn notLoggedIn={!hasSharedIdentity} processing={processing} promptDisabled={command.prompt && !prompt} onClick={hasSharedIdentity ? handleTrigger : popupGrant}>
							{!hasSharedIdentity ? <>Press to share your identity</> : processing ? <>Sending</> : command.prompt && !prompt ? <>Enter prompt</> : <>Activate</>}
						</OverlayBtn>
					)}
				</OverlayWrapper>
			)}
		</OverlayContain>
	);
}
